/* HS4 product page v2: reviews line, discovery cue, sticky buy bar controller */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const STAR = '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M10 1.8l2.4 5.1 5.5.7-4 3.8 1 5.5L10 14.2 5.1 16.9l1-5.5-4-3.8 5.5-.7z" fill="currentColor"/></svg>';
  const CHEV = '<svg class="hs4-rating__chev" viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M7 4l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- reviews ---------- */
  const findTabs = () => {
    const tabs = [...document.querySelectorAll('[role="tab"], button')].filter(b => /(Ürün|Mağaza) değerlendirmeleri/.test(b.textContent));
    const prod = tabs.find(b => /Ürün değerlendirmeleri/.test(b.textContent));
    const store = tabs.find(b => /Mağaza değerlendirmeleri/.test(b.textContent));
    return prod && store ? [prod, store] : null;
  };
  const count = el => Number((/\((\d+)\)/.exec(el.textContent) || [])[1] || NaN);
  const stars = avg => '<span class="hs4-rating__stars" aria-hidden="true"><span class="hs4-rating__base">' + STAR.repeat(5) + '</span><span class="hs4-rating__fill" style="width:' + Math.max(0, Math.min(100, (avg / 5) * 100)).toFixed(0) + '%">' + STAR.repeat(5) + '</span></span>';

  /* the store score comes from Judge.me's public review feed (all pages), so nothing in the widget is clicked */
  const readStoreAverage = async n => {
    try {
      const cached = JSON.parse(sessionStorage.getItem('hs4_store_rating') || 'null');
      if (cached && cached.n === n && Date.now() - cached.t < 6 * 3600e3) return cached.avg;
    } catch (e) {}
    const shop = (window.Shopify && Shopify.shop) || '';
    if (!shop) return null;
    const url = p => 'https://cdn.judge.me/reviews/all_reviews_js_based?widget_type=review-widget&page=' + p + '&review_type=shop-reviews&sort_by=created_at&sort_dir=desc&widget_theme=standard&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify';
    const first = await (await fetch(url(1))).json();
    const total = (first.pagination && first.pagination.total_pages) || 1;
    const rows = [...(first.reviews || [])];
    for (let p = 2; p <= total; p++) rows.push(...((await (await fetch(url(p))).json()).reviews || []));
    const ratings = rows.map(r => Number(r.rating)).filter(Boolean);
    if (!ratings.length || ratings.length !== n) return null;
    const avg = ratings.reduce((a, b) => a + b, 0) / ratings.length;
    try { sessionStorage.setItem('hs4_store_rating', JSON.stringify({ avg, n, t: Date.now() })); } catch (e) {}
    return avg;
  };

  /* Doğrulanmış müşteri değerlendirmeleri (Hardstone Geri Bildirim) varsa üstteki çip onlardan okunur ve o bölüme götürür;
     yoksa Judge.me çipi aşağıdaki gibi çalışmaya devam eder (paralel dönem). */
  const ownRating = () => {
    const box = document.getElementById('degerlendirmeler');
    const title = $('.product__title');
    if (!box || !title) return false;
    const avg = parseFloat(String(box.dataset.avg || '').replace(',', '.'));
    const n = Number(box.dataset.count || 0);
    if (!avg || !n) return false;
    const cur = $('.hs4-rating[data-own]');
    if (cur && cur.dataset.own === n + ':' + avg) return true;
    document.querySelectorAll('.hs4-rating').forEach(el => el.remove());
    const link = document.createElement('a');
    link.className = 'hs4-rating'; link.href = '#degerlendirmeler'; link.dataset.own = n + ':' + avg;
    link.innerHTML = stars(avg) + '<strong>' + avg.toFixed(1).replace('.', ',') + '</strong><span>' + n + ' doğrulanmış değerlendirme</span>' + CHEV;
    link.addEventListener('click', e => { e.preventDefault(); box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); });
    title.after(link);
    rated = true;
    return true;
  };

  let rated = false;
  const rating = async pair => {
    if (rated) return;
    const title = $('.product__title');
    if (!title) return;
    const prodN = count(pair[0]), storeN = count(pair[1]);
    const target = pair[0].closest('.shopify-section') || pair[0];
    const link = document.createElement('a');
    link.className = 'hs4-rating'; link.href = '#';
    if (prodN > 0) {
      const avg = (/(\d(?:[.,]\d)?)/.exec(($('[class*="average-rating-display"]') || {}).textContent || '') || [])[1];
      if (!avg) return;
      link.innerHTML = stars(parseFloat(avg.replace(',', '.'))) + '<strong>' + avg.replace(',', '.') + '</strong><span>' + prodN + ' değerlendirme</span>' + CHEV;
    } else if (storeN > 0) {
      link.classList.add('hs4-rating--store');
      link.innerHTML = '<svg class="hs4-rating__shield" viewBox="0 0 20 20" width="15" height="15" aria-hidden="true"><path d="M10 2l6 2.2v5c0 3.7-2.4 6.4-6 8-3.6-1.6-6-4.3-6-8v-5z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M7.2 9.8l2 2 3.6-3.8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + storeN + ' mağaza değerlendirmesi</span>' + CHEV;
    } else return;
    link.addEventListener('click', e => { e.preventDefault(); target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); });
    document.querySelectorAll('.hs4-rating').forEach(el => el.remove());
    title.after(link);
    rated = true;
    if (prodN === 0 && storeN > 0) {
      /* open the store tab only once the reviews area is on screen (no page jump) */
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); pair[1].click(); } }, { rootMargin: '0px 0px 200px 0px' });
        io.observe(target);
      }
      try {
        const avg = await readStoreAverage(storeN);
        if (avg) {
          link.classList.add('hs4-rating--store-scored');
          link.innerHTML = stars(avg) + '<strong>' + avg.toFixed(1) + '</strong><span>' + storeN + ' mağaza değerlendirmesi</span>' + CHEV;
        }
      } catch (e) {}
    }
  };
  let ratingTimer = null;
  const startRating = () => {
    clearInterval(ratingTimer);
    rated = false;
    let tries = 0;
    ratingTimer = setInterval(() => {
      if (ownRating()) { clearInterval(ratingTimer); return; }
      const pair = findTabs();
      if (pair) { clearInterval(ratingTimer); rating(pair); }
      else if (++tries > 40) clearInterval(ratingTimer);
    }, 500);
  };

  /* ---------- discovery cue ---------- */
  let cueTimer = null;
  const startCue = () => {
    clearInterval(cueTimer);
    const cue = $('[data-hs4-cue]');
    if (!cue) return;
    let n = 0;
    cueTimer = setInterval(() => {
      const d = document.getElementById('hs2-discovery');
      if (d) {
        clearInterval(cueTimer);
        cue.hidden = false;
        cue.addEventListener('click', e => {
          e.preventDefault();
          (d.querySelector('.hs2-fe__section') || d).scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        });
      } else if (++n > 40) clearInterval(cueTimer);
    }, 500);
  };
  startRating();
  startCue();
  /* a pattern swap replaces the product block: rebuild the rating line and the cue for the new product */
  document.addEventListener('hs:pdp-swapped', () => { startRating(); startCue(); cta = null; sticky = null; schedule(); });

  /* ---------- sticky buy bar: appears only once the real button has scrolled away ---------- */
  const root = document.documentElement;
  let sticky = null, cta = null;
  const findCta = () => {
    const list = [...document.querySelectorAll('.hs-purchase-add, .product-form__submit, form[action*="/cart/add"] button[type="submit"]')]
      .filter(b => !b.closest('.hs-purchase-sticky') && b.offsetParent !== null);
    return list[0] || null;
  };
  const update = () => {
    sticky = sticky && document.contains(sticky) ? sticky : $('.hs-purchase-sticky');
    if (!sticky) return;
    cta = cta && document.contains(cta) ? cta : findCta();
    const passed = cta ? cta.getBoundingClientRect().bottom < 0 : scrollY > 700;
    document.body.toggleAttribute('data-hs4-cta-passed', passed);
    const shown = passed && !document.body.hasAttribute('data-hs-footer-visible');
    root.style.setProperty('--hs4-sticky-h', shown ? Math.round(sticky.getBoundingClientRect().height) + 'px' : '0px');
  };
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['data-hs-footer-visible', 'data-hs-buying-passed'] });
  update();
})();
